import { createDsSelectController } from '../../../../../shared-ui/ds/behaviorAdapters.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';
import { createSettingsReferenceV2SelectController } from './createSettingsReferenceV2SelectController.js';

export function createSettingsSelectController(options = {}) {
  if (options?.controlMode === 'reference-v2') {
    const normalized = { ...options };
    delete normalized.controlMode;
    return createSettingsReferenceV2SelectController(normalized);
  }
  return createDsSelectController(withSettingsPresentationMode(options));
}
